module.exports = __webpack_public_path__ + "img/logo-1.e53bf909.png";